import {
  Icon as ChakraIcon,
  ComponentWithAs,
  IconProps,
} from '@chakra-ui/react';
import { ReactNode } from 'react';

export interface IIconProps extends Omit<IconProps, 'css'> {
  children?: ReactNode;
  title?: string;
  description?: string;
}

export const Icon: ComponentWithAs<'svg', any> = ({
  children,
  title,
  description,
  ...props
}) => (
  <ChakraIcon {...props}>
    {title && <title>{title}</title>}
    {description && <desc>{description}</desc>}
    {children}
  </ChakraIcon>
);
